export default __webpack_public_path__ + "static/kostnadskalkyl_brf_langgatans_smedja-f2ff6686f4237571552390f6487efbf1.pdf";